import { Component } from '@angular/core';
import { DirectDashboardService } from '@app/modules/direct/services/direct-dashboard.service';

@Component({
  selector: 'sbnb-direct-sites-list',
  standalone: false,
  templateUrl: './direct-sites-list.component.html',
})
export class DirectSitesListComponent {
  constructor(public directDashboardService: DirectDashboardService) {}
}
